import { BuildingIncomeData } from '@client/api';
import i18n from 'i18next';

export const transformToExcelFormat = (
  data: BuildingIncomeData[],
  selectedRows: Set<string>,
  baseYear: number,
  comparisonYear: number,
) => {
  const rows: Record<string, any>[] = [];
  if (data.length === 0) return [{ [i18n.t('noData', { ns: 'reporting' })]: null }];
  data.forEach((item) => {
    if (selectedRows.has(item.buildingId) || selectedRows.size === 0) {
      rows.push({
        [i18n.t('rental.building', { ns: 'reporting' })]: item.buildingName,
        [i18n.t('rental.tenants', { ns: 'reporting' })]: item.tenantIncomes.length,
        [i18n.t('rental.baseYear', { year: baseYear, ns: 'reporting' })]: item.currentPeriodIncome.value,
        [i18n.t('rental.comparisonYear', { year: comparisonYear, ns: 'reporting' })]: item.comparisonPeriodIncome.value,
        [i18n.t('rental.diff', { year: baseYear, ns: 'reporting' })]: item.variance.absolute.value,
        [i18n.t('rental.trend', { ns: 'reporting' })]: item.variance.percentage,
      });
      item.tenantIncomes.forEach((tenant) => {
        rows.push({
          [i18n.t('rental.building', { ns: 'reporting' })]: null,
          [i18n.t('rental.tenants', { ns: 'reporting' })]: tenant.tenantName,
          [i18n.t('rental.baseYear', { year: baseYear, ns: 'reporting' })]: tenant.currentPeriodIncome.value,
          [i18n.t('rental.comparisonYear', { year: comparisonYear, ns: 'reporting' })]:
            tenant.comparisonPeriodIncome.value,
          [i18n.t('rental.diff', { year: baseYear, ns: 'reporting' })]: tenant.variance.absolute.value,
          [i18n.t('rental.trend', { ns: 'reporting' })]: tenant.variance.percentage,
        });
      });
    }
  });
  return rows;
};
